<template>
  <div class="quality-recommend">
    <div class="slider-banner swiper">
      <swiper class="swiper-wrapper" :options="RecommendSwiper">
        <swiperSlide
          class="swiper-slide"
          v-for="(item, index) in imgUrls"
          :key="index"
        >
          <img v-lazy="item.img" class="slide-image" />
        </swiperSlide>
      </swiper>
      <div class="swiper-pagination"></div>
    </div>
    <div class="title acea-row row-center-wrapper">
      <div class="line"></div>
      <div class="name">
        <span class="iconfont icon-cuxiaoguanli"></span>促销单品
      </div>
      <div class="line"></div>
    </div>
    <Promotion-good :benefit="goodsList"></Promotion-good>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import PromotionGood from "@components/PromotionGood";
import { getGroomList } from "@api/store";
import { mapGetters } from "vuex";
import { getHomeData, getShare, follow } from "@api/public";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { getUser,getUserOpenId, getMenuUser } from "@api/user";
export default {
  name: "GoodsPromotion",
  components: {
    swiper,
    swiperSlide,
    PromotionGood
  },
  computed: mapGetters(["isLogin"]),
  props: {},
  data: function() {
    return {
      imgUrls: [],
      goodsList: [],
      RecommendSwiper: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      }
    };
  },
  mounted: function() {
    this.getIndexGroomList();
    this.setOpenShare();
  },
  methods: {
    getIndexGroomList: function() {
      let that = this;
      getGroomList(4)
        .then(res => {
          that.imgUrls = res.data.banner;
          that.goodsList = res.data.list;
        })
        .catch(function(res) {
          this.$dialog.toast({ mes: res.msg });
        });
    },setOpenShare() {
      if (isWeixin()) {
        if(this.isLogin){

          getUser().then(res => {
            var href = location.href;

            href =
                    href.indexOf("?") === -1
                            ? href + "?spread=" + res.data.uid
                            : href + "&spread=" + res.data.uid;
            var nickname = res.data.nickname;


            getShare().then(res => {
              var data = res.data.data;
              var configAppMessage = {
                desc: '['+nickname+'邀请] '+data.synopsis,
                title: data.title,
                link: href,
                imgUrl: data.img
              };
              openShareAll(configAppMessage);
            });
          })
        }else{
          getShare().then(res => {
            var data = res.data.data;
            var configAppMessage = {
              desc: data.synopsis,
              title: data.title,
              link: location.href,
              imgUrl: data.img
            };
            openShareAll(configAppMessage);
          });
        }


      }
    }
  }
};
</script>
